import {
  Button,
  Container,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import Constants from "../Variables/Constants";

export default class LeadsList extends Component {
  state = {
    leads: [],
    page: 1,
    limit: 10,
    search: "",
    total: 0,
    nextPage: false,
    prevPage: false,
    requestError: "",
  };

  componentDidMount() {
    this.fetchLeads();
  }

  buildUrl = (pageOverride) => {
    const query = new URLSearchParams({
      page: pageOverride || this.state.page,
      limit: this.state.limit,
    });

    if (this.state.search.trim()) {
      query.set("search", this.state.search.trim());
    }

    return `${Constants.getUrls.getLeadsList}?${query.toString()}`;
  };

  handleRequestError = (error, fallbackState = {}) => {
    this.setState({
      ...fallbackState,
      requestError:
        error?.response?.data?.message || error?.message || "Failed to load leads",
    });
  };

  fetchLeads = (pageOverride) => {
    axios
      .get(this.buildUrl(pageOverride))
      .then((res) => {
        const data = res.data.data || {};

        this.setState({
          leads: data.docs || [],
          total: data.totalDocs || 0,
          nextPage: data.hasNextPage || false,
          prevPage: data.hasPrevPage || false,
          page: data.page || pageOverride || this.state.page,
          requestError: "",
        });
      })
      .catch((error) => {
        this.handleRequestError(error, {
          leads: [],
          total: 0,
          nextPage: false,
          prevPage: false,
        });
      });
  };

  handleSearch = () => {
    this.setState({ page: 1 }, () => this.fetchLeads(1));
  };

  render() {
    return (
      <Container maxWidth="xl">
        <Snackbar
          open={Boolean(this.state.requestError)}
          autoHideDuration={4000}
          onClose={() => this.setState({ requestError: "" })}
          message={this.state.requestError}
        />
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6">Leads List</Typography>
            <Typography variant="body2" color="textSecondary">
              Showing visitors who submitted details and have not placed an order.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} style={{ display: "flex", gap: 10 }}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              placeholder="Search name or mobile"
              value={this.state.search}
              onChange={(e) => this.setState({ search: e.target.value })}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  this.handleSearch();
                }
              }}
            />
            <Button variant="contained" color="primary" onClick={this.handleSearch}>
              Search
            </Button>
          </Grid>
        </Grid>

        <br />

        <Paper>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Mobile</TableCell>
                  <TableCell>Product</TableCell>
                  <TableCell>Created At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.leads.map((lead, index) => (
                  <TableRow key={lead._id}>
                    <TableCell>
                      {(this.state.page - 1) * this.state.limit + index + 1}
                    </TableCell>
                    <TableCell>{lead.name}</TableCell>
                    <TableCell>{lead.mobile}</TableCell>
                    <TableCell>{lead.product_id?.name || "-"}</TableCell>
                    <TableCell>
                      {lead.createdAt
                        ? new Date(lead.createdAt).toLocaleString()
                        : "-"}
                    </TableCell>
                  </TableRow>
                ))}

                {this.state.leads.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No leads found
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Grid container justifyContent="space-between" alignItems="center" style={{ marginTop: 16 }}>
          <Typography variant="body2">Total: {this.state.total}</Typography>
          <div>
            <Button
              disabled={!this.state.prevPage}
              onClick={() => this.fetchLeads(this.state.page - 1)}
            >
              Previous
            </Button>
            <Button
              disabled={!this.state.nextPage}
              onClick={() => this.fetchLeads(this.state.page + 1)}
            >
              Next
            </Button>
          </div>
        </Grid>
      </Container>
    );
  }
}
